export default __webpack_public_path__ + "static/media/hh.cb023668.png";